import React, { useEffect, useState } from 'react'

import { GET_IMAGES_TIMEOUT_MS } from '../../constants/images'

type TimeoutFallbackImageProps = {
  src: string
  fallbackSrc: string
  alt: string
  timeout?: number
}

const fallbackStyle: React.CSSProperties = { padding: '1.5em' }

const ImageWithFallback: React.FC<TimeoutFallbackImageProps> = ({
  src,
  fallbackSrc,
  alt,
  timeout = GET_IMAGES_TIMEOUT_MS,
}) => {
  const [imgSrc, setImgSrc] = useState(src)
  const [loaded, setLoaded] = useState(false)
  const [style, setStyle] = useState<React.CSSProperties>(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!loaded) {
        setImgSrc(fallbackSrc)
        setStyle(fallbackStyle)
      }
    }, timeout)

    return () => clearTimeout(timer)
  }, [loaded, timeout, fallbackSrc])

  const handleLoad = () => {
    setLoaded(true)
  }

  const handleError = () => {
    setImgSrc(fallbackSrc)
    setStyle(fallbackStyle)
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      onLoad={handleLoad}
      onError={handleError}
      {...(style && { style })}
    />
  )
}

export default ImageWithFallback
